module.exports = __webpack_public_path__ + "static/media/blog-background.8611e33b.jpg";